import axios from "axios";

export const getIpAddress = async () => {
  const res = await axios.get("https://geolocation-db.com/json/");
  return res.data.IPv4;
};

export const appendConsent = (sms: boolean, email: boolean, phone_call: boolean) => {
  const consent: string[] = [];
  if (sms) consent.push("sms");
  if (email) consent.push("email");
  if (phone_call) consent.push("phone_call");
  return consent;
};
